export default __webpack_public_path__ + "static/media/arrowLeft.840dd547.svg";